import styles from "../../common/AlertCard.scss"; 
import Toggle from "../../common/Toggle";
import BudgetAssistantInfoPopup from "../../common/BudgetAssistantInfoPopup";
import BudgetAssistantTurnOnPopup from "./Presentational/baTurnOnPopup";
import  HoverBAEmail from "./Common/hoverBAEmail";
import  HoverBAPhone from "./Common/hoverBAPhone";
import BaErrorBox from "./Common/baErrorBox";
import { getLocalizedStrings } from "../../centralizedLocalizedString";
import BaTurnOffPopup from "./Presentational/baTurnOffPopup";
import ReactHtmlParser from 'react-html-parser';
    
class BudgetAssistant extends React.Component {    
  constructor(props) {
    super(props);
    this.state={
      prefData:"",emailOn:null,phoneOn:null,textOn:null,checked:null,isOpen:false,isShowPopup:false,hoverData:'',
      hoverModal:false,hoverPhoneModal:false,baIneligible:false,baIneligibleErrMsg:"",dropDownData:"",isErrorCard:false,preferenceData:"",
      hoverType:'',categoryType:'',isShowViewEdit:false, avgBillDetails: '',uPreferenceError:false,toggleDisabled:true,
      };
    
    this. imageMail_On=drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_MailOn.svg';
    this. imageMail_Off=drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_MailOff.svg';
    this. imagePhone_On=drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_PhoneOn.svg';
    this. imagePhone_Off=drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_PhoneOff.svg';
    this. imageText_On=drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_TextOn.svg';
    this. imageText_Off=drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_TextOff.svg';
    this.imageInfo=drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_Information.svg';
    this.strings = getLocalizedStrings('BaAlerts');
    this.initialPositionValue = window.getComputedStyle(document.body).position;
    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this); 
  }
  viewHoverPopUp =()=>{ 
    if(this.props.preferenceData.email_id.length >0){
      this.setState({ hoverModal: true , categoryType:'3'});
    }
  }
  viewHoverPhone =(category)=>{ 
    if(category===1 && this.props.preferenceData.phoneNo.length > 0){
      this.setState({ hoverData: this.props.preferenceData.phoneNo ,hoverPhoneModal: true, hoverModal: false,hoverType:'text', categoryType:'1'});
    } else if(category===2 && this.props.preferenceData.textNo.length > 0){
      this.setState({ hoverData: this.props.preferenceData.textNo ,hoverPhoneModal: true,hoverModal: false,hoverType:'voice', categoryType:'2' });
    }
  }
  
  componentDidUpdate() {
    // Bind the event listener
    if(this.state.categoryType==='3') {
      document.addEventListener("mousedown", this.handleEmailClose);
    }else{
      document.addEventListener("mousedown", this.handlePhoneClose);
    }
    document.addEventListener('mousedown', this.handleClickOutside);
  }
  componentWillUnmount(){
    if(this.state.categoryType==='3') {
      document.removeEventListener("mousedown", this.handleEmailClose);
    }else{
      document.removeEventListener("mousedown", this.handlePhoneClose);
    }
    document.removeEventListener('mousedown', this.handleClickOutside);
  }
  handleEmailClose=()=>{ 
    this.state.hoverModal ? this.setState({ hoverModal: false }) : null;
  }
  handlePhoneClose=()=>{ 
    this.state.hoverPhoneModal ? this.setState({ hoverPhoneModal: false }) : null;
  }
  componentWillReceiveProps(nextProps) {
    if (this.props !== nextProps) {
    this.setState(
      {
        prefData:nextProps.preferenceData,
        emailOn:nextProps.preferenceData.email_id.length>0?true:false,
        phoneOn:nextProps.preferenceData.phoneNo.length>0?true:false,
        textOn:nextProps.preferenceData.textNo.length>0?true:false,
    },() => {
        this.handle();
    });
  }
}

handle(){   //Added new rate types check such as NBTV, NBTA, NEMV, NEMA to the existing condition to restrict BA enrollment as part of NBT4
    this.setState({checked:((this.state.emailOn ||this.state.phoneOn || this.state.textOn)&&this.props.baEnrollmentDetailsVO.enrolledStatus === 'TRUE' && (!["NEMV", "NEMA", "NBTV", "NBTA"].includes(this.props.billingRateType))) ? true : false,dropDownData: this.props.dropDownData,toggleDisabled:false});
    this.imageMailOn=this.state.emailOn ? <img src={this.imageMail_On} alt="Mail Image On" />:<img src={this.imageMail_Off} alt="Mail Image Off" />;
    this.imagePhoneOn=this.state.phoneOn ? <img src={this.imagePhone_On} alt="Phone Image On" /> : <img src={this.imagePhone_Off} alt="Phone Image Off" />;
    this.imageTextOn=this.state.textOn ? <img src={this.imageText_On} alt="Text Image On" /> : <img src={this.imageText_Off} alt="Text Image Off" />;
}
handleToggleChange = (checked) => { //Added new rate types check such as NBTV, NBTA, NEMV, NEMA to the existing condition to restrict BA enrollment as part of NBT4
  if(checked) {
      if(["NEMV", "NEMA", "NBTV", "NBTA"].includes(this.props.billingRateType)){
        this.setState({baIneligible: true,baIneligibleErrMsg:this.strings.budaIneligibleErrMsg});
      } else {
    app.centralizedService.checkBaEligibility(this.props.selectedAccount.contractNumber).then(
    (response) => {
      if(response.eligible || this.props.baEnrollmentDetailsVO.enrolledStatus==="TRUE"){
        if(!_.isEmpty(response.averageBillDetails) && !_.isEmpty(response.averageBillDetails.avgSummerBill) && !_.isEmpty(response.averageBillDetails.avgWinterBill)){
          this.setState({ isShowPopup: true, avgBillDetails : response.averageBillDetails });
          window.scrollTo(0,0);
        }else{
          this.setState({isShowPopup: true, avgBillDetails : '' });
          window.scrollTo(0,0);
        }
      }else{
          let errorMsg = (response.errorObj[0].messageNumber === "136") ? this.strings.budaProcessingErrMsg : this.strings.budaIneligibleErrMsg;
          this.setState({baIneligible: true,baIneligibleErrMsg:errorMsg});
      }
    },(error) => {
      this.setState({baIneligible: true,baIneligibleErrMsg:this.strings.budaIneligibleErrMsg});
    }); }
  }else {
    this.setState({isShowPopup: true});
    window.scrollTo(0,0);
  }
}
closePopup = () => {
  if(this.state.uPreferenceError){
    this.props.refreshPage(this.props.accountData.contractAccountNumber, this.props.selectedAccount.contractNumber, this.props.selectedAccount.premiseNumber,true, this.props.accountData.bpNumber, this.props.accountData.bpCategory);
  }
  this.setState({isShowPopup: false,isShowViewEdit:false});
}
showViewEditPopup(){
  window.aUtils.sendAAEvent("button","budgetAssistantView/Edit");
  app.centralizedService.checkBaEligibility(this.props.selectedAccount.contractNumber).then(
    (response) => {
      if(!_.isEmpty(response.averageBillDetails) && !_.isEmpty(response.averageBillDetails.avgSummerBill) && !_.isEmpty(response.averageBillDetails.avgWinterBill)){
        this.setState({ isShowViewEdit: true,isShowPopup:true, avgBillDetails : response.averageBillDetails }, () => { });
      }else{
        this.setState({ isShowViewEdit: true,isShowPopup:true, avgBillDetails : '' }, () => { });
      }
      window.scrollTo(0,0);
    },(error) => {
      this.setState({ isShowViewEdit: true,isShowPopup:true, avgBillDetails : '' }, () => { });
    });
}
isSuccessObjectExist = (result) => {
  return result.some((eachObj) => {
    return eachObj.messageNo === '029' && eachObj.messageType === 'S';
  });}
// adding 600ms delay for refresh when its single account(Fix for ANC-877)
refreshPage = ()=>{
    let timeout = this.props.isMultiAcc === 1 ? 0 : 600;
    setTimeout(() => {
        this.props.refreshPage(this.props.accountData.contractAccountNumber, this.props.selectedAccount.contractNumber, this.props.selectedAccount.premiseNumber,false, this.props.accountData.bpNumber, this.props.accountData.bpCategory);    
    }, timeout);}

baEnrollClick(requestObj,summerSpendingGoals,winterSpendingGoals,selectedFrequency){
  let processType = this.props.baEnrollmentDetailsVO.enrolledStatus==="TRUE" ? '03' : '01';
  app.centralizedService.baEnroll(requestObj,summerSpendingGoals,winterSpendingGoals,selectedFrequency,this.props.accountData,this.props.selectedAccount,this.props.mainBpNumber,processType).then(
    (response) =>{
      if(this.isSuccessObjectExist(response.idpEnrollmentResponse[0].enrollmentResponse.outputMess.results[0].messages.results)){
        if(response.shouldCheckPreferenceErr && _.isEmpty(response.idpEnrollmentResponse[0].prefrenceObject.message)){
          let updatedState = { ...this.state };           
          updatedState.isErrorCard=true;
          updatedState.uPreferenceError=true;
          this.setState(updatedState);
        }else{
          this.closePopup();
          this.refreshPage(); 
        }
      }else{           
        let updatedState = { ...this.state };           
        updatedState.isErrorCard=true, updatedState.uPreferenceError=false;
        this.setState(updatedState);
      }
    }, (error) => {
    this.setState({isErrorCard: true});
  });}

baDeEnrollClick =()=>{
  window.aUtils.sendAAEvent("button","budgetAssistantTurnOff");
  app.centralizedService.baDeenroll(this.props.accountData, this.props.formattedDataForBuda, this.props.mainBpNumber).then(
      (response )=>{     
      if(!response.errorCode){
        this.setState({checked: false, isErrorCard: false},()=>{
          this.props.removePreference('buda', 'formattedDataForBuda');
          this.closePopup();
          this.refreshPage();
        });      
      }else{           
        this.setState({isErrorCard:true});
      }
    },(error) => {       
    this.setState({isErrorCard:true});   
    });     
  }
  onModifyCustomerPreference(requestObj, addNewDevieDetailFlag, deleteDeviceDetailFlag) {
        let dropDownData = this.state.dropDownData;
        if(requestObj.deviceType==="email"){
            let newObj={
              "email": requestObj.modifiedValue,"standardIndicatorEmail": "",  "objectKey": "", "record_guid": "NEW",
              "channel": "INT", "sequenceNumber": "",  "status": "",
              "removeFromDate": null, "addModifyFromDate": null, "addModifyToDate": null
          };
          dropDownData.emailSet.push(newObj);
        }
        else if(requestObj.deviceType==="voice"){
          let newObj={
            "telephoneNumber": requestObj.maskedValue,
            "encryptedPhoneNumber":requestObj.modifiedValue,
            "standardIndicatorVoice": "", "objectKey": "", "record_guid": "NEW", "channel": "TEL",
            "sequenceNumber": "", "indicatorSmsEnabled": "X", "indicatorTelephone": "", "status": "",
            "removeFromDate": null,
            "addModifyFromDate": null,
            "addModifyToDate": null
          };
          dropDownData.phoneSet.push(newObj);
          let mobileObject={...newObj, "channel": "PAG"};
          dropDownData.mobileSet.push(mobileObject);
        }else{
          let newObj={
            "telephoneNumber": requestObj.maskedValue,
            "encryptedPhoneNumber":requestObj.modifiedValue,
            "standardIndicatorVoice": "", "objectKey": "", "record_guid": "NEW", "channel": "PAG",
            "sequenceNumber": "", "indicatorSmsEnabled": "X", "indicatorTelephone": "", "status": "",
            "removeFromDate": null,
            "addModifyFromDate": null,
            "addModifyToDate": null
          };
          dropDownData.mobileSet.push(newObj);
          let mobileObject={...newObj, "channel": "TEL"};
          dropDownData.phoneSet.push(mobileObject);
        }
        this.props.updateDropDownData(dropDownData);
  }
  
overlayFocusController() {
  if(this.state.isShowPopup) {
    document.body.style.position = 'fixed';
    document.body.style.width = '100%';
  } else {
    document.body.style.position = this.initialPositionValue;
    document.body.style.removeProperty("width");
  }} 
onHoverOverEvent =(e)=>{
  if(e.type === "mouseenter"){
    this.setState({infoPopUp:true});}}
onHoverOutEvent = (e) =>{this.setState({infoPopUp:false});}
toolTipKeyPress= (e) =>{
  if(e.key === "Enter"){
    this.setState({infoPopUp:!this.state.infoPopUp});}}
setWrapperRef = (node) => {this.wrapperRef = node;}
handleClickOutside(event) {
  if (this.wrapperRef && !this.wrapperRef.contains(event.target)) 
  {this.closePopup();}
}
 render() {
   this.overlayFocusController();
    let budgetAssistanceInfoPopup = this.state.infoPopUp ? <div><BudgetAssistantInfoPopup handleClose={this.togglePopup} infoPopupTxt={ReactHtmlParser(this.props.staticContent.infoPopupTxt)} /> </div>: null;
    let turnOnOffPopup = !this.state.checked || this.state.isShowViewEdit ? <BudgetAssistantTurnOnPopup strings={this.strings} closePopup={this.closePopup} baEnrollmentDetailsVO={this.props.baEnrollmentDetailsVO}
      onModifyCustomerPreference={this.onModifyCustomerPreference.bind(this)} baEnrollClick={this.baEnrollClick.bind(this)} averageBillDetails={this.state.avgBillDetails}
      serviceAccountData={this.props.selectedAccount} selectedAccount={this.props.selectedAccount} dropDownData={this.state.dropDownData} mainBpNumber={this.props.mainBpNumber} 
      formattedData={this.props.formattedDataForBuda} isErrorCard={this.state.isErrorCard} uPreferenceError={this.state.uPreferenceError} isViewEdit={this.state.isShowViewEdit} />: <BaTurnOffPopup setWrapper={this.setWrapperRef} handleClose={this.closePopup} accountData={this.props.accountData} selectedAccount={this.props.selectedAccount}  baDeEnrollClick={this.baDeEnrollClick} isErrorCard={this.state.isErrorCard} /> ;
    let showPopup = this.state.isShowPopup ? turnOnOffPopup : null;
    let showIneligibleErr = this.state.baIneligible ? <BaErrorBox message={this.state.baIneligibleErrMsg} /> : null;
    let viewEditSection = (this.state.checked) ?
    <div className={styles.ButtonSection}>
        <span>
            <span onClick={this.viewHoverPopUp.bind(this)}> {this.imageMailOn}</span>
            <span className={styles.MarginLeft16} onClick={this.viewHoverPhone.bind(this,2)}>{this.imageTextOn}</span>
            <span className={styles.MarginLeft16} onClick={this.viewHoverPhone.bind(this,1)}>{this.imagePhoneOn}</span>
           <button id="budgetAssistantView" className={styles.ViewEditButton} onClick={this.showViewEditPopup.bind(this)}>{this.strings.budaViewEditBtn}</button>
        </span>
    </div> : null;
    return (
        <div>
            <div className={[styles.AlertCards, styles.relativePos].join(' ')}>
                <div className={styles.MainContainer}>
                    <div className={styles.LeftContainer}>
                        <div className={styles.AlertCardData} onMouseLeave={this.onHoverOutEvent}>
                            <p className={styles.AlertCardTitle} id={'budgetAssistanceInfoPopUp'} onMouseEnter={this.onHoverOverEvent} onClick={this.onHoverOverEvent}>
                                {this.strings.budaHeader1}
                                <span className={styles.InfoIcon}>{this.strings.budaHeader2}<img tabIndex={0} onKeyPress={this.toolTipKeyPress} className={styles.iconAlign} src={this.imageInfo} alt="Info Icon"  /></span>
                            </p>
                           
                            {budgetAssistanceInfoPopup}
                          
                            <p className={styles.AlertCardSubtitle} onMouseEnter={this.onHoverOutEvent}> {ReactHtmlParser(this.props.staticContent.subTxt)}</p>
                            {viewEditSection}
                            {this.state.hoverModal && <HoverBAEmail  preferenceData={this.props.preferenceData.email_id}  handleClose={this.handleEmailClose.bind(this)} />}
                            {this.state.hoverPhoneModal && <HoverBAPhone  preferenceDataPhone={this.state.hoverData} hoverText={this.state.hoverType} handlePhoneClose={this.handlePhoneClose.bind(this)} />} 
                        </div>
                    </div>
                    <div className={styles.DividerLine} />
                    <div className={styles.RightContainer}>
                        <div className={styles.SwitchAlign}>
                            <Toggle id="budgetAssitant" isToggleOn={this.state.checked} handleChange={this.handleToggleChange.bind(this)} isDisabled={this.state.toggleDisabled} />
                        </div>
                    </div>
                </div>
                {showIneligibleErr}
                {showPopup}
            </div>
        </div>
        );
    }
}
export default BudgetAssistant;
